import React from 'react';
import { StyledBadge, StyledContainer } from './index.styles.js';
import {} from '@oneaudi/unified-web-alpha-common';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const Badge = ({ semanticShape, label, alert, labelPosition = 'trailing', count, className, margin, ...rest }) => {
    const countIsNumber = typeof count === 'number';
    const countLimited = countIsNumber && count < 100 ? count : '99+';
    const a11yProps = pickA11yProps(rest);
    const dataProps = pickDataProps(rest);
    if (label) {
        return (React.createElement(StyledContainer, { className: className, margin: margin, ...a11yProps, ...dataProps },
            labelPosition === 'leading' && label,
            React.createElement(StyledBadge, { alert: alert, semanticShape: semanticShape, count: countIsNumber }, alert ? '!' : countIsNumber ? countLimited : null),
            labelPosition === 'trailing' && label));
    }
    return (React.createElement(StyledBadge, { alert: alert, count: countIsNumber, semanticShape: semanticShape, className: className, margin: margin, ...a11yProps, ...dataProps }, alert ? '!' : countIsNumber ? countLimited : null));
};
//# sourceMappingURL=index.js.map